<!-- Bar search -->
<ng-container *ngIf="appearance === 'bar'">
    <button
        mat-icon-button
        *ngIf="!opened"
        (click)="open()">
        <mat-icon [svgIcon]="'heroicons_outline:search'"></mat-icon>
    </button>
    <div
        class="absolute inset-0 flex items-center shrink-0 z-99 bg-card"
        *ngIf="opened"
        @slideInTop
        @slideOutTop>
        <mat-icon
            class="absolute ml-6 sm:ml-8"
            [svgIcon]="'heroicons_outline:search'"></mat-icon>
        <input
            class="w-full h-full px-16 sm:px-18"
            [formControl]="searchControl"
            [matAutocomplete]="matAutocomplete"
            [placeholder]="'Search...'"
            (keydown)="onKeydown($event)"
            #barSearchInput>
        <mat-autocomplete
            class="max-h-128 sm:px-2 border-t rounded-b shadow-md"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            #matAutocomplete="matAutocomplete">
            <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="resultSets && !resultSets.length">
                No results found!
            </mat-option>
            <ng-container *ngFor="let resultSet of resultSets">
                <mat-optgroup class="flex items-center mt-2 px-2">
                    <span class="text-sm font-semibold tracking-wider text-secondary">{{resultSet.label.toUpperCase()}}</span>
                </mat-optgroup>
                <ng-container *ngFor="let result of resultSet.results">
                    <mat-option
                        class="group relative mb-1 py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        [routerLink]="handleSearchSelect(resultSet.id, result)"
                        [value]="result.value">
                        <!-- Skills -->
                        <ng-container *ngIf="resultSet.id === 'skills'">
                            <ng-container *ngTemplateOutlet="skillResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Agents -->
                        <ng-container *ngIf="resultSet.id === 'agents'">
                            <ng-container *ngTemplateOutlet="agentResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Points-Of_Contact -->
                        <ng-container *ngIf="resultSet.id === 'pocs'">
                            <ng-container *ngTemplateOutlet="pocResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Scripts -->
                        <ng-container *ngIf="resultSet.id === 'scripts'">
                            <ng-container *ngTemplateOutlet="scriptResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Dispositions -->
                        <ng-container *ngIf="resultSet.id === 'dispositions'">
                            <ng-container *ngTemplateOutlet="dispResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                    </mat-option>
                </ng-container>
            </ng-container>
        </mat-autocomplete>
        <button
            class="absolute top-1/2 right-5 sm:right-7 shrink-0 w-10 h-10 -mt-5"
            mat-icon-button
            (click)="close()">
            <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
</ng-container>

<!-- Basic search -->
<ng-container *ngIf="appearance === 'basic'">
    <div class="w-full sm:min-w-80">
        <mat-form-field
            class="w-full"
            [subscriptSizing]="'dynamic'">
            <mat-icon
                matPrefix
                [svgIcon]="'heroicons_outline:search'"></mat-icon>
            <input
                matInput
                [formControl]="searchControl"
                [matAutocomplete]="matAutocomplete"
                [placeholder]="'Search...'"
                (keydown)="onKeydown($event)">
        </mat-form-field>
        <mat-autocomplete
            class="max-h-128 mt-1 rounded"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            #matAutocomplete="matAutocomplete">
            <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="resultSets && !resultSets.length">
                No results found!
            </mat-option>
            <ng-container *ngFor="let resultSet of resultSets; trackBy: trackByFn">
                <mat-optgroup class="flex items-center mt-2 px-2">
                    <span class="text-sm font-semibold tracking-wider text-secondary">{{resultSet.label.toUpperCase()}}</span>
                </mat-optgroup>
                <ng-container *ngFor="let result of resultSet.results; trackBy: trackByFn">
                    <mat-option
                        class="group relative mb-1 py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        [routerLink]="result.link"
                        [value]="result.value">
                        <!-- Skills -->
                        <ng-container *ngIf="resultSet.id === 'skills'">
                            <ng-container *ngTemplateOutlet="skillResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Agents -->
                        <ng-container *ngIf="resultSet.id === 'agents'">
                            <ng-container *ngTemplateOutlet="agentResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Points-Of_Contact -->
                        <ng-container *ngIf="resultSet.id === 'pocs'">
                            <ng-container *ngTemplateOutlet="pocResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Scripts -->
                        <ng-container *ngIf="resultSet.id === 'scripts'">
                            <ng-container *ngTemplateOutlet="scriptResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Dispositions -->
                        <ng-container *ngIf="resultSet.id === 'dispositions'">
                            <ng-container *ngTemplateOutlet="dispResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                    </mat-option>
                </ng-container>
            </ng-container>
        </mat-autocomplete>
    </div>
</ng-container>


<!-- Contact result template -->
<ng-template
    #skillResult
    let-skill>
    <div class="flex items-center">
        <div class="flex shrink-0 items-center justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
<!--            <img-->
<!--                *ngIf="skill.avatar"-->
<!--                [src]="skill.avatar">-->
<!--            <mat-icon-->
<!--                class="m-0 icon-size-5 text-primary dark:text-primary-400"-->
<!--                *ngIf="!skill.avatar"-->
<!--                [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>-->
            <mat-icon class="m-0 icon-size-5 text-primary dark:text-primary-400" [ngClass]= "skill.mediaTypeIcon">{{skill.mediaTypeIcon}}</mat-icon>
        </div>
        <div class="ml-3 truncate">
            <span [innerHTML]="skill.skillName"></span>
        </div>
    </div>
</ng-template>


<!-- Agents result template -->
<ng-template
    #agentResult
    let-agent>
    <div class="flex items-center">
        <div class="flex shrink-0 items-center justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
            <img
                *ngIf="agent.avatar"
                [src]="agent.avatar">
            <mat-icon
                class="m-0 icon-size-5 text-primary dark:text-primary-400"
                *ngIf="!agent.avatar"
                [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        </div>
        <div class="ml-3 truncate">
            <span [innerHTML]="agent.firstName + ' ' + agent.lastName "></span>
        </div>
    </div>
</ng-template>

<!-- POC result template -->
<ng-template
    #pocResult
    let-poc>
    <div class="flex items-center">
        <div class="flex shrink-0 items-center justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
            <mat-icon class="m-0 icon-size-5 text-primary dark:text-primary-400">
                {{poc.mediaTypeIcon}}
            </mat-icon>
        </div>
        <div class="flex flex-col p-2">
            <div
                class="truncate leading-normal"
                [innerHTML]="poc.ContactDescription"></div>
            <div class="truncate leading-normal text-sm text-secondary">
                {{poc.ContactAddress}}
            </div>
        </div>
    </div>
</ng-template>

<!-- Script result template -->
<ng-template
    #scriptResult
    let-script>
    <div class="flex items-center">
        <div class="flex shrink-0 items-center justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
            <mat-icon
                class="type-icon m-0 icon-size-5 text-primary dark:text-primary-400"
                [ngClass]="'mediaType' + script.mediaTypeId" matTooltip="{{script.mediaTypeName}}">
            </mat-icon>
        </div>
        <div class="ml-3 truncate">
            <span [innerHTML]="script.scriptName"></span>
        </div>
    </div>

</ng-template>

<!-- POC result template -->
<ng-template
    #dispResult
    let-disp>
    <div class="flex items-center">
        <div class="flex shrink-0 items-center justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
            <mat-icon
                class="mr-0 text-hint"
                [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
        </div>
        <div class="flex flex-col p-2">
            <div
                class="truncate leading-normal"
                [innerHTML]="disp.dispositionName"></div>
            <div class="truncate leading-normal text-sm text-secondary">
                {{disp.classificationName}}
            </div>
        </div>
    </div>
</ng-template>
